import { _isNotBlank } from '@/littledash';
import type { ID } from '@/model/Common.model';

export const isRegisteringOnBehalf = (owner?: ID | null): boolean => _isNotBlank(String(owner ?? ''));
